// import axios from "axios";
// const baseURL = process.env.REACT_APP_GET_OPERATION_HOME_API;

// const getFilteredDataAPI = async (body, params) => {
//   const searchParams = new URLSearchParams(params);
//   const response = await axios.post(`${baseURL}&${searchParams}`, body, {
//     headers: {
//       "Content-Type": "application/json",
//     },
//   });
//   response.data.duration = {
//     hour: response?.data?.duration?.hours,
//     minute: response?.data?.duration?.minutes,
//     second: response?.data?.duration?.seconds,
//   };
//   return response?.data;
// };

// export default getFilteredDataAPI;

// import axios from "axios";
// import CryptoJS from "crypto-js";

// const baseURL = process.env.REACT_APP_GET_OPERATION_HOME_API;

// // Secret key for encryption (must match the backend key)
// const SECRET_KEY = "1234567890abcdef1234567890abcdef";

// // Function to encrypt the payload
// const encryptPayload = (data) => {
//   const ciphertext = CryptoJS.AES.encrypt(
//     JSON.stringify(data),
//     SECRET_KEY
//   ).toString();
//   return ciphertext;
// };

// function decryptFunction(ciphertext, key) {
//   // Decrypt
//   let bytes = CryptoJS.AES.decrypt(ciphertext, key);
//   let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//   return decryptedData;
// }

// const getFilteredDataAPI = async (body, params) => {
//   const searchParams = new URLSearchParams(params);

//   // Encrypt the body payload
//   const encryptedBody = {
//     encryptedData: encryptPayload(body),
//   };

//   // Send the encrypted payload to the backend
//   const response = await axios.post(
//     `${baseURL}&${searchParams}`,
//     encryptedBody,
//     {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     }
//   );

//   const resData = decryptFunction(response.data, SECRET_KEY);

//   console.log("Filtered Data response ------------------>\n", resData);

//   return resData;
// };

// export default getFilteredDataAPI;

import axios from "axios";
import CryptoJS from "crypto-js";
import { handleLogout } from "./getRequest";

const baseURL = process.env.REACT_APP_GET_OPERATION_HOME_API;

// Secret key for encryption (must match the backend key)
const SECRET_KEY = "1234567890abcdef1234567890abcdef";

// Function to encrypt the payload
const encryptPayload = (data) => {
  const ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY,
  ).toString();
  return ciphertext;
};

function decryptFunction(ciphertext, key) {
  // Decrypt
  let bytes = CryptoJS.AES.decrypt(ciphertext, key);
  let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
}

const getFilteredDataAPI = async (body, params) => {
  const authToken = localStorage.getItem("authToken");

  const searchParams = new URLSearchParams(params);

  console.log("Final API Payload:", {
    body: JSON.parse(JSON.stringify(body)),
    params,
    urlParams: searchParams.toString(),
  });

  // Encrypt the body payload
  const encryptedBody = {
    encryptedData: encryptPayload(body),
  };

  // Send the encrypted payload to the backend
  let response;
  try {
    response = await axios.post(`${baseURL}&${searchParams}`, encryptedBody, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    });
  } catch (error) {
    if (error.status === 401) {
      console.log("Token expired");
      handleLogout();
      return;
    }
    throw error;
  }

  const resData = decryptFunction(response.data, SECRET_KEY);

  console.log("Filtered Data response ------------------>\n", resData);

  return resData;
};

export default getFilteredDataAPI;
